import { createContext, useReducer } from "react";
import requestService from "../services/requestService";

const LiveHodoReducer = (state, action) => {
  const { type, payload } = action;
  switch (type) {
    case "SET_CABIN_DATA_SUCCESS":
      return {
        ...state,
        cabins: payload,
      };
    case "IS_JOIN_CABIN":
      return {
        ...state,
        isJoinCabin: payload,
      };
    case "SELECTED_CABIN_SUCCESS":
      return {
        ...state,
        selectedCabinData: payload,
      };
    case "SELECTED_ROLE_SUCCESS":
      return {
        ...state,
        selectedRole: payload,
      };
    case "SET_LIVE_ROOM_DETAIL_SUCCESS":
      return {
        ...state,
        liveRoomDetail: payload,
      };
    case "SET_CONFERENCE_ROOM_DETAIL_SUCCESS":
      return {
        ...state,
        conferenceRoomDetail: payload,
      };
    case "SET_CIRCLE_ROOM_DETAIL_SUCCESS":
      return {
        ...state,
        circleRoomDetail: payload,
      };
    case "RESET_CONTEXT_STATE_SUCCESS":
      return {
        ...state,
        ...payload,
      };
    case "SELECTED_SCREEN_SHARE_SUCCESS":
      return {
        ...state,
        selectedScreenShare: payload,
      };
    case "GET_CONFERENCE_SCHEDULES_SUCCESS":
      return {
        ...state,
        conferenceSchedules: payload,
      };
    default:
      return { ...state };
  }
};

export const LiveHodoContext = createContext();

export const LiveHodoContextProvider = ({ children }) => {
  const initialState = {
    cabins: [],
    isJoinCabin: true,
    selectedCabinData: null,
    selectedRole: "",
    liveRoomDetail: null,
    conferenceRoomDetail: null,
    circleRoomDetail: null,
    isAudioShareDisabled: false,
    isScreenShareDisabled: false,
    selectedScreenShare: null,
    conferenceSchedules: null,
  };
  const [stateCtx, dispatch] = useReducer(LiveHodoReducer, initialState);

  const setCabins = value => {
    dispatch({
      type: "SET_CABIN_DATA_SUCCESS",
      payload: value,
    });
  };

  const setIsJoinCabin = value => {
    dispatch({
      type: "IS_JOIN_CABIN",
      payload: value,
    });
  };

  const setSelectedCabinData = data => {
    dispatch({
      type: "SELECTED_CABIN_SUCCESS",
      payload: data,
    });
  };
  const setSelectedRole = data => {
    dispatch({
      type: "SELECTED_ROLE_SUCCESS",
      payload: data,
    });
  };

  const setLiveRoomDetail = data => {
    dispatch({
      type: "SET_LIVE_ROOM_DETAIL_SUCCESS",
      payload: data,
    });
  };

  const setConferenceRoomDetail = data => {
    dispatch({
      type: "SET_CONFERENCE_ROOM_DETAIL_SUCCESS",
      payload: data,
    });
  };

  const setCircleRoomDetail = data => {
    dispatch({
      type: "SET_CIRCLE_ROOM_DETAIL_SUCCESS",
      payload: data,
    });
  };

  const setIsAudioShareDisabled = () => {
    stateCtx.isAudioShareDisabled = !stateCtx.isAudioShareDisabled;
  };

  const setIsScreenShareDisabled = () => {
    stateCtx.isScreenShareDisabled = !stateCtx.isScreenShareDisabled;
  };

  const resetContextState = () => {
    dispatch({
      type: "RESET_CONTEXT_STATE_SUCCESS",
      payload: initialState,
    });
  };

  const setSelectedScreenShare = data => {
    dispatch({
      type: "SELECTED_SCREEN_SHARE_SUCCESS",
      payload: data,
    });
  };

  const getConferenceSchedules = async paramsData => {
    try {
      const params = {
        ...paramsData,
      };
      const res = await requestService
        .getListConferenceSchedules(params)
        .then(data => data.json());

      if (!res) return;

      dispatch({
        type: "GET_CONFERENCE_SCHEDULES_SUCCESS",
        payload: res,
      });
      return res;
    } catch (error) {
      console.log(error);
    }
  };

  const contextData = {
    stateCtx,
    setCabins,
    setIsJoinCabin,
    setSelectedCabinData,
    setSelectedRole,
    setLiveRoomDetail,
    setConferenceRoomDetail,
    setCircleRoomDetail,
    setIsAudioShareDisabled,
    setIsScreenShareDisabled,
    resetContextState,
    setSelectedScreenShare,
    getConferenceSchedules,
  };

  return (
    <LiveHodoContext.Provider value={contextData}>
      {children}
    </LiveHodoContext.Provider>
  );
};
